export const CUSTOMER_PERSONAL = 'customer_personal';
export const CUSTOMER_FILES = 'customer_files';
export const CUSTOMER_FINANCIAL = 'customer_financial';
export const CUSTOMER_BIRTH = 'customer_birth';
export const CUSTOMER_DOCUMENT = 'customer_document';
export const CUSTOMER_CNH = 'customer_cnh';
export const CUSTOMER_PHONES = 'customer_phones';
export const CUSTOMER_EMAILS = 'customer_emails';
export const CUSTOMER_REFERENCES = 'customer_references';
export const CUSTOMER_PARTNERS = 'customer_partners';
export const CUSTOMER_FAMILY = 'customer_family';
export const CUSTOMER_SPOUSE = 'customer_spouse';
export const CUSTOMER_ADDRESS = 'customer_address';
export const CUSTOMER_PREVIOUS_ADDRESS = 'customer_previous_address';
export const CUSTOMER_ALTERNATIVE_ADDRESS = 'customer_alternative_address';
export const CUSTOMER_JOB = 'customer_job';
export const CUSTOMER_PROFESSIONAL = 'customer_professional';
export const CUSTOMER_PROFESSIONAL_ADDRESS = 'customer_professional_address';
export const CUSTOMER_PROFESSIONAL_INCOME = 'customer_professional_income';
export const CUSTOMER_PREVIOUS_PROFESSIONAL = 'customer_previous_professional';
export const CUSTOMER_ACCOUNTANT = 'customer_accountant';
export const CUSTOMER_BANK = 'customer_bank';
export const CUSTOMER_HISTORY = 'customer_history';
export const CUSTOMER_OBS = 'customer_obs';
